module.exports = __webpack_public_path__ + "static/3-why-me-77c18319454b1c98ee709f8f13235f41.svg";